import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setInfo(data); setStatus("done"); await refresh(); return;
        }
        if (data.status === "expired" || tries > 8) { setStatus("timeout"); return; }
      } catch { /* retry */ }
      tries++; setTimeout(poll, 1500);
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-[#07080D] text-white flex items-center justify-center p-6">
      <div className="glass rounded-3xl border border-emerald-500/30 p-10 max-w-md text-center">
        {status === "checking" && (<><div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-5" /><p>Confirming your payment…</p></>)}
        {status === "done" && (<>
          <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto mb-4" />
          <h2 className="font-display text-2xl font-black mb-2">Payment Successful!</h2>
          <p className="text-gray-400 mb-6">{info?.kind === "cash" ? "Cash has been added to your balance." : "Coins have been added to your account."}</p>
          <Link to="/wallet" className="inline-block px-6 py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-cyan-600 font-semibold">Back to Wallet</Link>
        </>)}
        {(status === "error" || status === "timeout") && (<>
          <XCircle className="w-16 h-16 text-amber-400 mx-auto mb-4" />
          <h2 className="font-display text-2xl font-black mb-2">Still processing</h2>
          <p className="text-gray-400 mb-6">Your balance will update shortly. Check your wallet in a moment.</p>
          <Link to="/wallet" className="inline-block px-6 py-3 rounded-xl bg-white/10 font-semibold">Go to Wallet</Link>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#07080D] text-white flex items-center justify-center p-6">
      <div className="glass rounded-3xl border border-white/10 p-10 max-w-md text-center">
        <XCircle className="w-16 h-16 text-gray-500 mx-auto mb-4" />
        <h2 className="font-display text-2xl font-black mb-2">Payment Cancelled</h2>
        <p className="text-gray-400 mb-6">No charge was made. You can try again anytime.</p>
        <Link to="/wallet" className="inline-block px-6 py-3 rounded-xl bg-white/10 font-semibold">Back to Wallet</Link>
      </div>
    </div>
  );
}
